import { render } from "./PaymentLoader.vue?vue&type=template&id=413dd8b9&scoped=true"
import script from "./PaymentLoader.vue?vue&type=script&lang=js"
export * from "./PaymentLoader.vue?vue&type=script&lang=js"

import "./PaymentLoader.vue?vue&type=style&index=0&id=413dd8b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-413dd8b9"]])

export default __exports__